import User from '../User';
import Library from './utility/Library';
import sourceCutscenes from '../library/cutscenes.json';
import { localizeContent } from '../ContentTranslation';
import images from '../library/images.json';
import { play, getMusic, stopMusic, stopCategory } from '../SoundManager';

const allcutscenes = localizeContent(sourceCutscenes);

const cutscenes = {};

Object.values(allcutscenes).forEach(cutscene => {
    const { champion, type, value } = cutscene;

    if (!cutscenes[champion]) {
        cutscenes[champion] = {};
    }

    if (!cutscenes[champion][type]) {
        cutscenes[champion][type] = value ? {} : cutscene;
    }

    if (value) {
        cutscenes[champion][type][value] = cutscene;
    }
});

export default class CutsceneManager {

	queue = [];

	static get cutscenes () {

		return cutscenes;
	}

	constructor (master, dispatch) {

		this.master = master;
		this.dispatch = dispatch;
	}

	start (cutscene) {

		if (!User.canAccessCutscene(cutscene)) {
			if (this.callback)
				this.call();
			else
				this.dispatch();
			return false;
		}
		// Empty content placeholders complete immediately so story battles can proceed.
		if (User.isCutsceneSoftDisabled(cutscene) || cutscene.sequence.length === 0) {
			if (!cutscene.fast)
				User.watch(cutscene.key);
			if (this.callback)
				this.call();
			else
				this.dispatch();
			return false;
		}

		if (!cutscene.fast)
			User.watch(cutscene.key);
		this.music = getMusic();
		stopMusic();
		this.cutscene = Object.assign({}, cutscene);
		this.cutscene.sequence = this.cutscene.sequence.map(e => Object.assign({}, e));
		this.cutscene.sequence.forEach((e, i) => {
			e.first = i === 0;
			e.hideLeft = e.left === "";
			e.hideRight = e.right === "";
			e.hideLeft2 = e.left2 === "";
			e.hideRight2 = e.right2 === "";
			["background", "img", "speaker", "text", "left", "right", "left2", "right2", "focus"].forEach(prop => {
				if (prop === "background" || prop === "left" || prop === "right" || prop === "left2" || prop === "right2")
					e[prop] = images[e[prop]];
				if (e[prop] === undefined || (e[prop] === "" && (prop === "left" || prop === "right" || prop === "left2" || prop === "right2"))) {
					if (e.first)
						e[prop] = undefined;
					else if (prop === "left" && this.cutscene.sequence[i-1].hideLeft || prop === "right" && this.cutscene.sequence[i-1].hideRight  || prop === "left2" && this.cutscene.sequence[i-1].hideLeft2  || prop === "right2" && this.cutscene.sequence[i-1].hideRight2)
						e[prop] = "";
					else {
						e[prop] = this.cutscene.sequence[i-1][prop];
					}
				}
			});
			["rightscale", "leftscale", "right2scale", "left2scale"].forEach(prop => {
				if (e[prop] === undefined) {
					if (e.first)
						e[prop] = undefined;
					else {
						e[prop] = this.cutscene.sequence[i-1][prop];
					}
				}
			});
		})
		this.sequence = 0;
		this.dispatch(this.cutscene.sequence[this.sequence]);
		return true;
	}

	get intro () {

		return this.cutscene && this.cutscene.value && this.cutscene.value.endsWith("intro")
	}

	get run () {

		return this.master.state.model;
	}

	get championKey () {

		return this.run.champion.model.key;
	}

	next () {

		if (this.queue.length > 0) {
			let next = this.queue.shift();
			this.event(next.n, next.callback);
		}
	}

	back () {

		if (!this.cutscene || this.sequence === 0)
			return;
		this.sequence--;
		this.dispatch(this.cutscene.sequence[this.sequence]);
	}

	skip () {

		if (!this.cutscene)
			return;
		delete this.sequence;
		delete this.cutscene;
		if (this.music) {
			play(this.music, "music");
			delete this.music;
		}
		if (this.callback) {
			this.dispatch();
			this.callback();
			delete this.callback;
		}
		this.next();
	}

	continue () {

		if (!this.cutscene)
			return;
		this.sequence++;
		if (this.sequence > this.cutscene.sequence.length - 1)
			this.skip();
		else
			this.dispatch(this.cutscene.sequence[this.sequence]);
	}

	call () {

		this.callback();
		delete this.callback;
		this.next();
	}

	deactivate () {

		this.deactivated = true;
	}

	event(n, callback) {

		if (this.callback) {
			this.queue.push({n, callback});
			return;
		}

		this.callback = callback;
		let championKey = this.run?.champion?.model.key;

		if (this.deactivated) {
			this.call();
			return;
		}

		switch (n.type) {
		case "storyevent": {
			let cutscene = cutscenes[User.champion]["story"]["event" + User.dataQuest?.value + "-intro"];
			if (cutscene && !User.hasSeen(cutscene.key))
				this.start(cutscene);
			else
				this.call()
			break;
		}
		case "victory": {
			if (this.run.storyEvent && !this.run.memory) {
				const quest = User.questFor(this.run.difficultySetting, this.run.champion.model.key);
				const cutscene = cutscenes[championKey]["story"]["event" + quest?.value + "-victory"];
				if (cutscene)
					setTimeout(() => this.start(cutscene), 2000);
				else
					this.call();
				break;
			}
			/*if (this.run.depth < 3 && this.run.quest && (!this.run.quest.premium || User.premium)) {
				let quest = Library.getQuest(this.run.quest);
				let cutscene = cutscenes[championKey]["story"]["boss" + this.run.depth];
				if (!User.hasSeen(cutscene.key) && quest.type === "floor")
					setTimeout(() => this.start(cutscene), 2000);
				else
					this.call()
			}
			else*/
				this.call()
			break;
		}
		case "newrun": {
			let cutscene = cutscenes[n.data[1]]["story"]["intro"];
			if (!User.hasSeen(cutscene.key)) {
				this.start(cutscene);
				break;
			}
			this.call();
			break;
		}
		case "enterroom": {
			let tutorial = cutscenes["-1"]["tutorial"]["intro"];
			let tutorialll = cutscenes["-1"]["tutorial"]["levellimit"];
			let tutorialmp = cutscenes["-1"]["tutorial"]["mazepower"];
			if (!User.hasSeen(tutorial.key))
				this.start(tutorial)
			else if (this.run.power >= 2 && !User.hasSeen(tutorialmp.key))
				this.start(tutorialmp)
			else if (this.run?.champion?.level >= 3 && !User.hasSeen(tutorialll.key))
				this.start(tutorialll)
			else
				this.call()
			break;
		}
		case "newfountain": {      
			let firstcs = null;
			User.storySceneLevels(this.championKey).forEach(([cs, lv]) => {
				if (firstcs)
					return;
				if (cutscenes[this.championKey]["story"][cs] && User.dataFor(this.championKey, this.run.difficultySetting).level >= lv && !User.hasSeen(cutscenes[this.championKey]["story"][cs].key))
					firstcs = cs;
			})
			if (firstcs) {
				let cutscene = cutscenes[this.championKey]["story"][firstcs];
				if (this.start(cutscene))
					User.watch(cutscene.key)
			}
			else
				this.call();
			break;
		}
		case "levelup": {
			if (cutscenes[this.championKey]["level up"]) {
				let cutscene = cutscenes[this.championKey]["level up"][this.run.champion.level+1];
				if (cutscene && !User.isCutsceneSoftDisabled(cutscene) && !User.hasSeen(cutscene.key))
					User.watch(cutscene.key)
			}
			//let speed = localStorage.getItem('options.growthsequences') || 'fast';
			/*if (!User.hasSeen(cutscene.key))
				this.start(cutscene)
			else*/
				this.call();
			break;
		}
		default:
			this.call();
			break;
		}
	}
}
